export default __webpack_public_path__ + "static/media/dialmantra-logo-icon.5940e27c.png";